const _ = require("underscore");

// todo merge gitlab back and front
async function isTokenValid(token) {
	return true;
}

export default {
	hex2rgb(hex, opacity) {
		hex = (hex + "").trim();

		let rgb = null;
		let match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

		if (!match) {
			return null;
		}

		rgb = {};

		hex = match[1];

		if (hex.length === 6) {
			rgb.r = parseInt(hex.substring(0, 2), 16);
			rgb.g = parseInt(hex.substring(2, 4), 16);
			rgb.b = parseInt(hex.substring(4, 6), 16);
		} else if (hex.length === 3) {
			rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
			rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
			rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
		}

		rgb.css = "rgb" + (opacity ? "a" : "") + "(";
		rgb.css += rgb.r + "," + rgb.g + "," + rgb.b;
		rgb.css += (opacity ? "," + opacity : "") + ")";

		return rgb;
	},
	standardize_json_all: function standardize_columns_all(data) {
		var columns = [];

		for (var j = 0; j < data.length; j++) {
			let column_keys = [];
			if (data.length > 0) column_keys = Object.keys(data[j]);
			columns = _.union(columns, column_keys);
		}

		var column_keys = [];
		if (data.length > 0) {
			for (var j = 0; j < data.length; j++) {
				column_keys = Object.keys(data[j]);
				let diff = columns.filter((x) => !column_keys.includes(x));
				for (var k = 0; k < diff.length; k++) {
					data[j][diff[k]] = "";
				}
			}
		}

		return data;
	},
	saveToFile(jsonData, filename) {
		let blob = new Blob([jsonData], { type: "text/plain;charset=utf-8;" });
		if (navigator.msSaveBlob) {
			// IE 10+
			navigator.msSaveBlob(blob, filename);
		} else {
			let link = document.createElement("a");
			if (link.download !== undefined) {
				// feature detection
				// Browsers that support HTML5 download attribute
				let url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", filename);
				link.style.visibility = "hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	},
	isTokenValid,
};
